import React, { useMemo } from "react"
import { Box } from "@chakra-ui/react"
import { getGridPositions } from "./lib/geometry"
import { useObjectLayer } from "./ObjectLayer"

const GRID_COLOR = "#A0AEC0"

type Props = {
  /** Draws the bounds' thirds and centre. */
  showGrid: boolean
}

/** The bounds' thirds and centre, which objects also snap to while it's shown. */
const GridOverlay = ({ showGrid }: Props) => {
  const { bounds, scale } = useObjectLayer()
  const { x: gridX, y: gridY } = useMemo(
    () => getGridPositions(bounds.width, bounds.height),
    [bounds.width, bounds.height],
  )
  if (!showGrid) return null

  const width = bounds.width * scale
  const height = bounds.height * scale

  return (
    <Box position="absolute" inset={0} pointerEvents="none" zIndex={999}>
      <svg width={width} height={height} style={{ position: "absolute", top: 0, left: 0 }}>
        {gridX.map((position) => (
          <line
            key={`grid-x-${position}`}
            x1={position * scale}
            y1={0}
            x2={position * scale}
            y2={height}
            stroke={GRID_COLOR}
            strokeWidth={1}
            strokeDasharray="4 4"
            opacity={0.55}
          />
        ))}
        {gridY.map((position) => (
          <line
            key={`grid-y-${position}`}
            x1={0}
            y1={position * scale}
            x2={width}
            y2={position * scale}
            stroke={GRID_COLOR}
            strokeWidth={1}
            strokeDasharray="4 4"
            opacity={0.55}
          />
        ))}
      </svg>
    </Box>
  )
}

export default React.memo(GridOverlay)
